<template>
  <div>
    <h2 class="margin-xl-bottom">TODO</h2>
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. At blanditiis consectetur eveniet labore laborum magnam molestias quis sed sit tempore! Cum et iste libero magnam nesciunt pariatur quidem sed tenetur?</p>

    <div class="article-space margin-max-bottom" ></div>
    <h2 class="margin-xl-bottom">TODO2</h2>
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. At blanditiis consectetur eveniet labore laborum magnam molestias quis sed sit tempore! Cum et iste libero magnam nesciunt pariatur quidem sed tenetur?</p>

  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";

export default {
  components: {

  },
  layout: {
    component: "default",
    params: {
      title: "justopp.services.pageTitle",
      subTitle: "justopp.services.pageSubtitle",
      //   containerClass: "margin-remove-vertical",
    },
  },
  middleware: {},
  props: {},
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "justopp.services.browserTitle",
  data() {
    return {

    };
  },
  computed: {

  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
